import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const ReviewsSection = () => {
  const reviews = [
    { name: "Maria Rodriguez", rating: 5, text: "Excellent service! I've been taking my car here for years and they always do fantastic work. Very trustworthy and fair pricing.", date: "March 15, 2024" },
    { name: "James Miller", rating: 5, text: "Sharp Deal Auto saved me when my transmission failed. They were honest about what needed to be done and completed the work quickly. Highly recommend!", date: "April 2, 2024" },
    { name: "Carlos Santos", rating: 5, text: "Great customer service and quality work. They explained everything clearly and my car runs better than ever. Will definitely be back.", date: "April 28, 2024" }
  ];

  return (
    <section id="reviews" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-primary text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
            <FontAwesomeIcon icon={faStar} className="mr-2" />
            4.8
            <span className="ml-1">Google Reviews</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">What Our Customers Say</h2>
          <p className="text-gray-600">
            Don't just take our word for it - see what our satisfied customers have to say about our services
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6">
              <div className="flex mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <FontAwesomeIcon key={i} icon={faStar} className="text-yellow-400 text-sm" />
                ))}
              </div>
              <p className="text-gray-700 mb-4 italic">"{review.text}"</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-900">{review.name}</p>
                  <p className="text-sm text-gray-500">{review.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="#contact"
            className="bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-secondary transition-colors inline-block"
          >
            Book Your Appointment Today
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;